// import 'components/person-image/person-image'
import 'components/content-wrapper/content-wrapper'
import 'components/header/header'
import 'components/button/button'
import 'components/link/link'
import 'components/card/card'
import 'components/step-wrapper/step-wrapper'
import 'components/footer/footer'
import 'components/page-loader/page-loader'
import 'components/steps/steps.js'
import 'utils/setVh.js'
import 'utils/sendAnalitics'
import 'components/gradient/gradient'
import 'components/cursor/cursor'
import 'components/circles/circles'
import 'components/counter/counter'



const initPage = () => {
    let progress = 0
    
    const interval = setInterval(() => {
        progress += 3

        if (progress >= 100) {
            const event = new CustomEvent('pageLoad')
            document.dispatchEvent(event)
            clearInterval(interval)
        }
    }, 20);
}

initPage()

